import React from 'react';

interface PageCardProps {
  children: React.ReactNode;
  className?: string;
}

const PageCard: React.FC<PageCardProps> = ({ children, className = '' }) => {
  return (
    <main className="flex-1 px-4 py-8 lg:py-12">
      <div className="w-full max-w-[1272px] mx-auto">
        <article className={`rounded-2xl bg-brand-secondary px-4 py-7 md:p-8 lg:p-12 ${className}`}>
          <div className="max-w-5xl mx-auto">
            {children}
          </div>
        </article>
      </div>
    </main>
  );
};

export default PageCard;
